import { CommonModule } from '@angular/common';
import { Component, ChangeDetectorRef, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SecurityService } from 'app/services/security.service';
import { FormsModule } from '@angular/forms';
import { environment } from '@env/environment';
import { catchError, switchMap, take, throwError } from 'rxjs';
import { set } from 'animejs';

@Component({
  selector: 'app-button-help',
  templateUrl: './button-help.component.html',
  imports: [CommonModule, FormsModule],
  styleUrl: './button-help.component.css'
})
export class ButtonHelpComponent {
  isMenuOpen = false;
  isHelpMessageVisible = true;
  isAnimatingOut = false;
  isDocumentModalVisible = false;
  isConfirmModalVisible = false;
  documentNumber: string = '';
  isLoading = false;
  errorMessage: string = '';
  private touchTimeout: any = null;
  router = inject(Router);

  colorOne = environment.colorOne;
  colorTwo = environment.colorTwo;

  constructor(private cdr: ChangeDetectorRef, private securityService: SecurityService) {}

  toggleMenu() {
    if (this.touchTimeout) {
      return;
    }

    if (this.isMenuOpen) {
      this.isAnimatingOut = true;
      this.cdr.detectChanges();

      this.touchTimeout = setTimeout(() => {
        this.isMenuOpen = false;
        this.isHelpMessageVisible = true;
        this.isAnimatingOut = false;
        this.touchTimeout = null;
        this.cdr.detectChanges();
      }, 300);
    } else {
      this.isMenuOpen = true;
      this.isHelpMessageVisible = false;
      this.cdr.detectChanges();

      this.touchTimeout = setTimeout(() => {
        this.touchTimeout = null;
      }, 300);
    }
  }

  closeMenu() {
    if (this.isMenuOpen && !this.isAnimatingOut) {
      this.isAnimatingOut = true;
      this.cdr.detectChanges();

      setTimeout(() => {
        this.isMenuOpen = false;
        this.isHelpMessageVisible = true;
        this.isAnimatingOut = false;
        this.cdr.detectChanges();
      }, 300);
    }
  }

  onHelp() {
    window.open('https://wa.me/3044416214', '_blank');
    this.closeMenu();
  }

  onReset() {
    this.closeMenu();
    this.isConfirmModalVisible = true;
    this.cdr.detectChanges();
  }

  confirmReset() {
    const consultor = localStorage.getItem('consultor');
    const version = localStorage.getItem('version');
    localStorage.clear();
    localStorage.removeItem('route');
    this.closeConfirmModal();
    localStorage.setItem('version', version || '');
    this.router.navigate(['/consultor', consultor]);
  }

  closeConfirmModal() {
    this.isConfirmModalVisible = false;
    this.cdr.detectChanges();
  }

  openDocumentModal() {
    this.closeMenu();
    setTimeout(() => {
      this.isDocumentModalVisible = true;
      this.documentNumber = '';
      this.errorMessage = '';
      this.cdr.detectChanges();
    }, 350);
  }

  closeDocumentModal() {
    this.isDocumentModalVisible = false;
    this.documentNumber = '';
    this.errorMessage = '';
    this.isLoading = false;
    this.cdr.detectChanges();
  }

  onSubmitDocument() {
    if (!this.documentNumber) {
      this.errorMessage = 'Por favor ingrese un número de documento';
      return;
    }

    const identification = parseInt(this.documentNumber);
    if (isNaN(identification) || identification <= 0) {
      this.errorMessage = 'Por favor ingrese un número de documento válido';
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';
    this.cdr.detectChanges();

    this.securityService.getResumeSession(identification).subscribe({
      next: (response: any) => {
        this.isLoading = false;
        if (response.ok && response.session) {
          localStorage.clear();
          localStorage.setItem('session', response.session);
          this.closeDocumentModal();
          this.getConsultor();
          this.getCheckpoint();

          console.log('Sesión reanudada exitosamente');
        } else {
          this.errorMessage = 'No hay un proceso abierto asociado a este documento.';
        }
        this.cdr.detectChanges();
      },
      error: (error: any) => {
        this.isLoading = false;
        this.errorMessage = 'No hay un proceso abierto asociado a este documento.';
        this.cdr.detectChanges();
        console.error('Error fetching session', error);
      }
    });
  }

  onResume() {
    this.openDocumentModal();
  }

  getConsultor() {
    this.securityService.getConsultor().subscribe({
      next: (response: any) => {
        const consultor = response.user;
        localStorage.setItem('consultor', consultor);
      },
      error: (error: any) => {
        console.error('Error obteniendo consultor:', error);
      }
    });
  }

  getCheckpoint() {
    this.securityService.getCheckpoint().subscribe({
      next: (response: any) => {
        const checkpoint = response.checkpoint;
        const checkpointNumber = Number(checkpoint.split('_').pop());
        let route = '';

        switch (checkpointNumber) {
          case 2:
            route = '/app/services';
            this.router.navigate(['/app', 'services']);
            break;
          case 3:
            route = '/app/basic';
            this.router.navigate(['/app', 'basic']);
            break;
          case 4:
            route = '/app/basic';
            this.router.navigate(['/app', 'basic']);
            break;
          case 5:
            route = '/app/address';
            this.router.navigate(['/app', 'address']);
            break;
          case 6:
            route = '/app/address';
            this.router.navigate(['/app', 'address']);
            break;
          case 7:
            route = '/app/balance';
            this.router.navigate(['/app', 'address']);
            break;
          case 8:
            route = '/app/foreign';
            this.router.navigate(['/app', 'balance']);
            break;
          case 9:
            route = '/app/foreign';
            this.router.navigate(['/app', 'foreign']);
            break;
          case 10:
            route = '/app/sign';
            this.router.navigate(['/app', 'sign']);
            break;
          case 11:
            route = '/app/finish';
            this.router.navigate(['/app', 'finish']);
            break;
          default:
            break;
        }

        if (route) {
          localStorage.setItem('route', route);
        }
        window.location.reload();
      },
      error: (error: any) => {
        console.error('Error obteniendo checkpoint:', error);
      }
    });
  }
}
